import React from 'react'

const FormTitle = (props) =>{
  return(
    <div className="form-text">
      <div className="text-block-2">To better understand your opportunity and maximize the upcoming scoping call, please complete the form below. One of our sales representatives will reach out within 24 hours.</div>
    </div>
  )
}

export default FormTitle



// WEBPACK FOOTER //
// ./src/components/FormText.js